import "../assets/style/vab.scss";
import "../assets/style/element-variables.scss";
export default {
  name: "PageLayout"
};